export default {"src":"/_next/static/media/arrowRight.c060358f.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};